// extracted by mini-css-extract-plugin
export default {"title":"General_title__0Cge8","boxForm":"General_boxForm__5tBh4","form":"General_form__SvCI0"};